import React from 'react';

import { Alert, Typography, type TypographyProps } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

export type RewardAmountKind = definitions['VoucherRewardKindOptionMeta']['key'];

type RewardAmountProps = {
  rewardAmount: number;
  rewardKind: RewardAmountKind;
  percentageAmount?: number;
  creditLabel?: string;
  showUnknownAlert?: boolean;
  component?: TypographyProps['component'];
};

export function RewardAmount({
  rewardKind,
  rewardAmount,
  percentageAmount,
  creditLabel = 'Credit',
  showUnknownAlert = true,
  component = 'span',
}: RewardAmountProps) {
  switch (rewardKind) {
    case 'discount':
      return <Typography component={component}>{rewardAmount}</Typography>;
    case 'provide_credit':
      return (
        <Typography component={component}>
          {rewardAmount} {creditLabel}
        </Typography>
      );

    case 'provide_credit_percentage':
      return (
        <Typography component={component}>
          {percentageAmount}% Credit ({rewardAmount})
        </Typography>
      );
    default:
      return showUnknownAlert ? (
        <Alert color="warning">
          RewardAmount is unknown {rewardKind} {rewardAmount}
        </Alert>
      ) : (
        <Typography component={component}>{rewardAmount}</Typography>
      );
  }
}
